

export const UnrealEngineTypes = {
    float: "rgb(60, 255, 0)",
    int32: "rgb(0, 234, 255)",
    bool: "rgb(213, 0, 0)",
    FString: "rgb(226, 5, 255)",
    FName: "rgb(255, 0, 153)",
    FVector: "rgb(255, 208, 0)",
    UObject: "rgb(0, 128, 255)",
    enum: "rgb(0, 39, 16)",
    struct: "rgb(0, 9, 104)"
}